<template>
  <div class="page-container">
    <md-app>
      <md-app-toolbar class="md-primary" md-elevation="0">
        <md-button class="md-icon-button" @click="toggleMenu" v-if="showDrawer && !menuVisible">
          <md-icon>
            <font-awesome-icon icon="bars" />
          </md-icon>
        </md-button>
        <span class="md-title">{{ pageTitle }}</span>
        <div class="md-toolbar-section-end">
          <layout-avatar-dropdown></layout-avatar-dropdown>
        </div>
      </md-app-toolbar>

      <md-app-drawer v-if="showDrawer" :md-active.sync="menuVisible" md-persistent="full">
        <md-toolbar class="md-transparent" md-elevation="0">
          <span></span>

          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon>
                <font-awesome-icon icon="arrow-left" />
              </md-icon>
            </md-button>
          </div>
        </md-toolbar>
        <form-list></form-list>
      </md-app-drawer>

      <md-app-content class="no-padding">
        <slot></slot>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import LayoutAvatarDropdown from './LayoutAvatarDropdown'
import FormList from '../FormList'

export default {
  name: 'LayoutBase',
  components: {
    LayoutAvatarDropdown,
    FormList
  },
  props: {
    showDrawer: {
      type: Boolean,
      default: true
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    menuVisible: false
  }),
  methods: {
    toggleMenu () {
      this.menuVisible = !this.menuVisible
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-padding {
    padding: 0;
  }
  .md-app {
    min-height: 100vh;
  }
  .md-app-container{
    overflow-x: hidden;
  }
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }
  .md-drawer.md-theme-default.md-persistent-full.md-left {
    border-right: none;
    box-shadow: 0 2px 3px rgba(10,10,10,.1);
  }
  .md-icon svg {
    width: 1rem;
  }
  .md-list-item:hover {
    background-color: whitesmoke;
    cursor: pointer;
  }
  .md-drawer .router-link-exact-active .md-list-item-text,
  .md-drawer .router-link-active .md-list-item-text {
    color: black;
    font-weight: bold;
  }
  .md-drawer .router-link-exact-active svg path,
  .md-drawer .router-link-active svg path {
    fill: black;
  }
  .md-toolbar.md-theme-default.md-primary {
    background-color: white;
    color: black;
    box-shadow: 0 2px 3px rgba(10,10,10,.1);
  }
  .md-toolbar.md-theme-default.md-primary .md-title,
  .md-toolbar.md-theme-default.md-primary .md-button:not([disabled]):not(.md-raised) {
    color: black;
  }
  .md-toolbar.md-theme-default.md-primary .md-icon svg path {
    fill: black;
  }
  .md-app-content {
    background-color: whitesmoke;
  }
  .md-list-item-content {
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutBase.vue